export default __webpack_public_path__ + "static/media/47.dd417667.jpg";